module.exports = __webpack_public_path__ + "static/media/APP_TimeMagician_152x174_6.0b7f5c5c.png";